import * as React from 'react';

import { DISABLED } from '../../utils/constants';

const LIGHT = 'light'

interface radioButtonProps {
  selected: boolean;
  label?: string;
  mode?: string;
  onClick?: (option?: any) => void;
  state?: string;
  value?: any;
  id?: any;
  ariaLabel?: string;
}

export const RadioButton = ({ label, mode = LIGHT, onClick, state, selected, value, id, ariaLabel, }: radioButtonProps) => {
  const radioButtonId = id || label
  const labelId = React.useId()
  const name = label && !ariaLabel ? { 'aria-labelledby': labelId, } : { 'aria-label': ariaLabel, }

  const elementClass = `${state === DISABLED ? DISABLED : ''} ${mode === LIGHT ? `${mode} focus-on-light` : `${mode} focus-on-dark`}`

  return (
    <div className="quill-radio-button-container">
      <button {...name} aria-checked={selected} className={`quill-radio-button interactive-wrapper ${selected ? 'selected' : 'unselected'} ${elementClass}`} id={radioButtonId} onClick={onClick} role="radio" type="button" value={value} >
        <div className="button-fill" />
      </button>
      {label && <label className={elementClass} htmlFor={radioButtonId} id={labelId}>{label}</label>}
    </div>
  );
};

export default RadioButton
